import { render, staticRenderFns } from "./SliderOnboardingScharffPoint.vue?vue&type=template&id=f8edc5ba&"
import script from "./SliderOnboardingScharffPoint.vue?vue&type=script&lang=js&"
export * from "./SliderOnboardingScharffPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports